module.exports = __webpack_public_path__ + "img/company5.41b6961e.jpg";